"use client";

import { useState } from "react";
import Link from "next/link";
import styles from "./offers.module.css";

export default function OffersCarousel({ offers, locale }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    if (!offers || offers.length === 0) return null;

    return (
        <div className={styles.carouselContainer}>
            <div
                className={styles.carouselTrack}
                style={{
                    transform: `translateX(${locale === 'ar' ? '' : '-'}${currentIndex * 100}%)`,
                    direction: locale === 'ar' ? 'rtl' : 'ltr'
                }}
            >
                {offers.map((offer, idx) => (
                    <div key={offer.id || idx} className={styles.carouselSlide}>
                        <div
                            className={styles.offerBanner}
                            style={{
                                backgroundImage: `linear-gradient(rgba(26, 54, 93, 0.85), rgba(26, 54, 93, 0.7)), url(${offer.image
                                    ? (offer.image.startsWith('http') ? offer.image : `${process.env.NEXT_PUBLIC_API_URL?.replace('/api', '') || ''}${offer.image}`)
                                    : '/images/offer-bg.jpg'
                                    })`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center'
                            }}
                            dir={locale === 'ar' ? 'rtl' : 'ltr'}
                        >
                            <div className={styles.content}>
                                <span className={styles.badge}>{locale === 'ar' ? 'عرض خاص' : 'Special Offer'}</span>
                                <h2 className={styles.title}>{offer.title_i18n?.[locale] || (locale === 'ar' ? offer.title_ar : offer.title) || offer.title}</h2>
                                <p className={styles.description}>{(offer.description_i18n?.[locale] || (locale === 'ar' ? offer.description_ar : offer.description) || offer.description)?.substring(0, 100)}...</p>
                                <Link href={`/${locale}/offers/${offer.seo?.slug || offer.id || offer.priority}`} className={styles.ctaBtn}>
                                    {locale === 'ar' ? 'عرض التفاصيل' : 'View Details'}
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {offers.length > 1 && (
                <div className={styles.dotsContainer}>
                    {offers.map((_, idx) => (
                        <button
                            key={idx}
                            className={`${styles.dot} ${idx === currentIndex ? styles.activeDot : ""}`}
                            onClick={() => setCurrentIndex(idx)}
                            aria-label={`Go to slide ${idx + 1}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
